import BaseScheme, { BaseSchemeType } from "../BaseScheme";

export type Question = {
  "@type": "Question";
  name: string;
  acceptedAnswer: {
    "@type": "Answer";
    text: string;
  };
};

export interface FaqPageSchemeType extends BaseSchemeType {
  "@context": "http://www.schema.org";
  "@type": "FAQPage";
  mainEntity: Question[];
};

class FaqPageScheme extends BaseScheme<FaqPageSchemeType> {
  constructor(path: string) {
    super(path, true);
    this.set("@type", "FAQPage" as any);
    this.set("mainEntity", [] as Question[]);
  }

  public addQuestion(name: string, text: string): this {
    const entity = this.getObject().mainEntity || [];

    entity.push({
      "@type": "Question",
      name,
      acceptedAnswer: {
        "@type": "Answer",
        text,
      },
    });

    this.set("mainEntity", entity as any);
    
    return this;
  }
}

export default FaqPageScheme;